import React, { useState, useEffect, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import FailureAlert from '../Common/Failure';
import { ThemeContext } from '../Common/ThemeProvider';
import Select from 'react-select';
import moment from 'moment';
import Alerts from 'react-s-alert';
import DatePicker from 'react-datepicker';
import DataTable from '../Common/DataTableList';

const AlertDetails = {
    AlertDesc: "",
    PartnerID: "",
    Type: 0,
    StartDate: null,
    EndDate: null,
    Status: 1,
    IsDeleted: 0
};

const AlertType = [
    { label: "Success", value: 1 },
    { label: "Announcement / Info", value: 2 },
    { label: "Danger", value: 3 }
];

const SendType = [
    { label: "All", value: 1 },
    { label: "Partner", value: 2 }
];

const Alert = () => {

    const { CurrentTheme } = useContext(ThemeContext);
    const [alertsData, setalertsData] = useState([]);
    const [Alert, setAlert] = useState(AlertDetails);
    const [displayAddAlerts, setdisplayAddAlerts] = useState("none");
    // eslint-disable-next-line
    const [TypeInfo, setTypeInfo] = useState(AlertType);
    const [PartnerInfo, setPartnerInfo] = useState([]);
    // eslint-disable-next-line
    const [SendInfo, setSendInfo] = useState(SendType);
    const [ShowPartner, setShowPartner] = useState(false);
    const [SelectedType, setSelectedType] = useState({ label: null, value: null });
    const [SelectedSendInfo, setSelectedSendInfo] = useState({ label: null, value: null });
    const [SelectedPartner, setSelectedPartner] = useState({ label: null, value: null });
    const [IsEdit, setIsEdit] = useState(0);
    const [SelectedAlertID, setSelectedAlertID] = useState("");

    useEffect(() => {
        FetchAlerts();
        if (PartnerInfo.length === 0) {
            FetchPartners();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchAlerts = () => {
        Axiosfetch(baseURL + "GetActiveAlerts", "GET", null, AlertDataSuccess, Failure);
    };

    const AlertDataSuccess = (data) => {
        if (data && data.length > 0) {
            setalertsData(data);
        }
        else {
            setalertsData([]);
        }
    };

    const FetchPartners = () => {
        Axiosfetch(baseURL + "GetActiveOrganizations", "GET", null, PartnerSuccess, Failure);
    };

    const PartnerSuccess = (data) => {
        if (data && data.length > 0) {
            var partnerData = [];

            var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;

            data.forEach(partner => {
                if (userData.OrganizationID !== partner._id && ((partner.ExpiryDate === undefined || partner.ExpiryDate === null) ||
                    (partner.ExpiryDate !== "" && moment() < moment(partner.ExpiryDate)))) {
                    partnerData.push({ label: partner.Name + " [MFI " + partner.City + "]", value: partner._id })
                }
            });

            setPartnerInfo(partnerData);
        }
    };

    const showAlerts = () => {
        setdisplayAddAlerts("block");
    };

    const hideAlerts = () => {
        setdisplayAddAlerts("none");

        setSelectedType({ label: null, value: null });
        setSelectedSendInfo({ label: null, value: null });
        setSelectedPartner({ label: null, value: null });
    };

    const OnSendTypeChange = (sendTypeData) => {
        let sendType = sendTypeData ? sendTypeData.value : 1;
        setShowPartner(sendType === 2);

        if (sendTypeData) {
            setSelectedSendInfo(sendTypeData);
        }
        else {
            setSelectedSendInfo({ label: null, value: null });
        }
    };

    const onTextChange = (e) => {
        setAlert({ ...Alert, [e.target.name]: e.target.value });
    };

    const onStartDateChange = (date) => {
        setAlert({ ...Alert, "StartDate": date });
    };

    const onEndDateChange = (date) => {
        setAlert({ ...Alert, "EndDate": date });
    };

    const setTypeChange = (alert) => {
        let alertType = alert ? alert.value : 0;
        setAlert({ ...Alert, "Type": alertType });
        if (alert) {
            setSelectedType(alert);
        }
        else {
            setSelectedType({ label: null, value: null });
        }
    };

    const setPartnerChange = (partner) => {
        let Selectedpartner = partner ? partner.value : "";
        setAlert({ ...Alert, "PartnerID": Selectedpartner });

        if (partner) {
            setSelectedPartner(partner);
        }
        else {
            setSelectedPartner({ label: null, value: null });
        }
    };

    const ValidateAlert = () => {
        let AlertErr = "";
        if (Alert.AlertDesc === "") {
            AlertErr = "Please enter Description.";
        }
        else if (Alert.Type === 0) {
            AlertErr = "Please select Alert Type.";
        }
        else if (Alert.StartDate === null) {
            AlertErr = "Please enter valid Start Date.";
        }
        else if (Alert.EndDate === null || moment() > moment(Alert.EndDate)) {
            AlertErr = "Please enter valid End Date.";
        }

        if (AlertErr !== "") {
            Alerts.error(AlertErr, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            return false;
        }

        return true;
    };

    const SaveAlertDetails = () => {
        if (ValidateAlert()) {
            let AlertData = Alert;
            AlertData.StartDate = moment.utc(AlertData.StartDate);
            AlertData.EndDate = moment.utc(AlertData.EndDate);
            AlertData.PartnerID = (!ShowPartner || AlertData.PartnerID === "") ? null : AlertData.PartnerID;

            if (IsEdit === 1) {
                AlertData._id = SelectedAlertID;
            }

            Axiosfetch(baseURL + (IsEdit === 0 ? "CreateAlert" : "EditAlert"), "POST", AlertData, CreateAlertSuccess, Failure);
            FetchAlerts();
        }
    };

    const CreateAlertSuccess = (data) => {
        if (data.success) {
            setAlert(AlertDetails);
            hideAlerts();
            setShowPartner(false);
            setIsEdit(0);

            Alerts.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
        else {
            Alerts.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const EditAlert = (alertID) => {
        setIsEdit(1);
        let selectedAlert = alertsData.filter(a => a._id === alertID);
        if (selectedAlert.length > 0) {
            selectedAlert.StartDate = new Date(selectedAlert.StartDate);
            let AlertData = {
                AlertDesc: selectedAlert[0].AlertDesc,
                PartnerID: selectedAlert[0].PartnerID,
                Type: selectedAlert[0].Type,
                StartDate: new Date(moment(selectedAlert[0].StartDate)),
                EndDate: new Date(moment(selectedAlert[0].EndDate)),
                Status: 1,
                IsDeleted: 0
            }
            setAlert(AlertData);
            setSelectedAlertID(alertID);

            let sendData = SendType.filter(s => s.value === (AlertData.PartnerID !== null ? 2 : 1));
            if (sendData.length > 0) {
                setSelectedSendInfo(sendData[0]);
            }
            else {
                setSelectedSendInfo({ label: null, value: null });
            }

            let alertData = AlertType.filter(a => a.value === AlertData.Type);

            if (alertData.length > 0) {
                setSelectedType(alertData[0]);
            }
            else {
                setSelectedType({ label: null, value: null });
            }

            if (AlertData.PartnerID !== null) {
                let partnerData = PartnerInfo.filter(p => p.value === AlertData.PartnerID);

                if (partnerData.length > 0) {
                    setSelectedPartner(partnerData[0]);
                }
            }
            else {
                setSelectedPartner({ label: null, value: null });
            }

            setShowPartner(AlertData.PartnerID !== null);
            showAlerts();
        }
        else {
            setAlert({});
        }

    };

    const DeleteAlert = (alertID) => {
        Axiosfetch(baseURL + "DeleteAlert", "POST", { _id: alertID }, DeleteAlertSuccess, Failure);
        FetchAlerts();
    };

    const DeleteAlertSuccess = (data) => {
        if (data.success) {
            setAlert(AlertDetails);
            hideAlerts();
            setShowPartner(false);
            setIsEdit(0);

            Alerts.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
        else {
            Alerts.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const GetAlertTypeInfo = (alertType) => {
        switch (alertType) {
            case 1: return "green";
            case 2: return "#005582";
            case 3: return "red";
            default: return "green";
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const columns = [
        {
            name: 'Type',
            width: "200px",
            selector: row => {
                return <div style={{ whiteSpace: "normal", textAlign: "left" }}>
                    <span style={{ color: GetAlertTypeInfo(row.Type) }}>{AlertType[row.Type - 1].label}</span>
                </div>
            },
            sortable: true,
        },
        {
            name: 'Description',
            width: "300px",
            selector: row => { return <div style={{ whiteSpace: "normal", textAlign: "left" }}>{row.AlertDesc}</div> },
            sortable: true,
        },
        {
            name: 'Partner',
            width: "200px",
            selector: row => {
                return <div style={{ whiteSpace: "normal" }}>
                    <div>{row.Organization.length > 0 ? (row.Organization[0].Name) : "-"}</div>
                    <div>{row.Organization.length > 0 ? `[${row.Organization[0].City}]` : ""}</div>
                </div>
            },
            sortable: true,
        },
        {
            name: 'Start Date',
            width: "200px",
            selector: row => `${moment(row.StartDate).local().format("DD/MM/YYYY")} 
            ${moment(row.StartDate).local().format("hh:mm:ss A")}`,
        },
        {
            name: 'End Date',
            width: "200px",
            selector: row => `${moment(row.EndDate).local().format("DD/MM/YYYY")} 
            ${moment(row.EndDate).local().format("hh:mm:ss A")}`,
        },
        {
            name: 'Actions',
            selector: row => {
                return <div><span className="ActionIcon" title="Edit" onClick={() => EditAlert(row._id)}
                    style={{ color: "#147a6f", paddingRight: "20px" }}><FontAwesomeIcon icon={faPen} /></span>
                    <span style={{ color: "#f61414" }} className="ActionIcon" title="Edit" onClick={() => DeleteAlert(row._id)}>
                        <FontAwesomeIcon icon={faTrash} /></span></div>
            }
        }
    ];

    return (
        <div>
            <Header></Header>
            <div style={{ border: "none", boxShadow: "none" }} className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                    <div className="offset-md-2 col-md-9 col-sm-9">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>Alerts</h5>
                    </div>
                    <div className="col-md-1 col-sm-3 align-left">
                        <span data-tip="Add User" className={`cursor font-size-15rem addIconFocus ${CurrentTheme}Color`} onClick={showAlerts}>
                            <FontAwesomeIcon icon={faPlus} />
                        </span>
                    </div>
                </div>
                <div className="row" style={{ padding: "15px" }}>
                    <DataTable columns={columns} data={alertsData} />
                </div>
            </div>
            <div id="myAddAlertModel" className="modal" style={{ display: displayAddAlerts, paddingTop: "60px" }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Add Alert</span>
                        <span className="close" onClick={hideAlerts}>&times;</span>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className="text-field" style={{ margin: "0" }}>
                                                <input placeholder="" name="AlertDesc" value={Alert.AlertDesc ? Alert.AlertDesc : ""}
                                                    onChange={(e) => onTextChange(e)}
                                                    type="text"></input>
                                                <span>Description<span className="mandatoryStar">*</span></span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div>
                                                <Select styles={{ borderRadius: "20px" }} isClearable={true} isSearchable={true} placeholder="Select Alert Type *"
                                                    value={SelectedType.value === null ? "" : SelectedType}
                                                    options={TypeInfo}
                                                    onChange={setTypeChange}></Select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div>
                                                <Select styles={{ borderRadius: "20px" }} isClearable={true} isSearchable={true} placeholder="Select Sender *"
                                                    value={SelectedSendInfo.value === null ? "" : SelectedSendInfo}
                                                    options={SendInfo}
                                                    onChange={OnSendTypeChange}></Select>
                                            </div>
                                        </td>
                                    </tr>
                                    {ShowPartner && (<tr>
                                        <td>
                                            <div>
                                                <Select styles={{ borderRadius: "20px" }} isClearable={true} isSearchable={true} placeholder="Select Partner *"
                                                    value={SelectedPartner.value === null ? "" : SelectedPartner}
                                                    options={PartnerInfo}
                                                    onChange={setPartnerChange}></Select>
                                            </div>
                                        </td>
                                    </tr>)}
                                    <tr>
                                        <td>
                                            <div className="text-field" style={{ padding: "10px", margin: "0" }}>
                                                <DatePicker className="TextInputStyle datepicker" style={{ borderBottom: "none" }}
                                                    onChange={onStartDateChange}
                                                    selected={Alert.StartDate}
                                                    name="StartDate"
                                                    showTimeSelect
                                                    timeIntervals={15}
                                                    timeCaption="time"
                                                    dateFormat="MMMM d, yyyy h:mm aa"></DatePicker>
                                                <span style={{ left: "30px", top: "25px", display: (Alert.StartDate !== null ? "none" : "block") }} className="datepickerPacking floating-span">Start Date<span className="mandatoryStar">*</span></span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="text-field" style={{ padding: "10px", margin: "0" }}>
                                                <DatePicker className="TextInputStyle datepicker"
                                                    onChange={onEndDateChange}
                                                    selected={Alert.EndDate}
                                                    name="EndDate"
                                                    showTimeSelect
                                                    timeIntervals={15}
                                                    timeCaption="time"
                                                    dateFormat="MMMM d, yyyy h:mm aa"></DatePicker>
                                                <span style={{ left: "30px", top: "25px", display: (Alert.EndDate !== null ? "none" : "block") }} className="datepickerPacking floating-span">End Date<span className="mandatoryStar">*</span></span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" style={{ textAlign: "right" }}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={SaveAlertDetails}>Save</button>
                                                    <button type="button" className="btn btn-default" onClick={hideAlerts}>Close</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
};

export default Alert;